<template>
	<div class="external-container">
        <div class="external-search clearfix">
			<a-button class="fr" icon="plus" @click="createExternalHandle()">发布信息</a-button>
        </div>
        <div class="external-content" @mousewheel="scrollChange" ref="scrollContainer">
            <ul ref="scrollEle">
                <li class="external-item" v-for="item in externalList" :key="item.id">
                    <div class="external-item_title" @click="viewExternal(item)">{{item.title}}</div>
                    <div class="external-item_description">{{ item.description }}</div>
                    <div class="external-item_info">
                        <span class="m-right-10">{{item.create_time | timeFromNow("YYYY-MM-DD")}}</span>
                        <span class="m-right-10">{{ item.created_by_user.name }}</span>
                        <span v-if="canOperate(item.created_by_user)"  @click="createExternalHandle(item)" class="m-right-10 external-item_update cursour">修改</span>
                        <span v-if="canOperate(item.created_by_user)"  @click="delExternalWordHandle(item)" class="del-color cursour">删除</span>
                    </div> 
                </li>
            </ul>
            <a-divider v-if="!hasMoreExternal && externalList.length" class="external-divider">已展示全部数据</a-divider>
            <a-empty  v-if="!hasMoreExternal && !externalList.length" class="p-top-10 p-bottom-10" description="暂无数据" />
        </div>
	</div>
</template>
  
<script>
import ExternalService from "@/api/externalService";
import { mapGetters } from "vuex";

export default {
	name: "external",
	components: {},
	data() {
		return {
			externalList: [],
			hasMoreExternal: true,
			loading: false,
			params: {
				school_id: undefined,
				after_id: undefined,
				limit: 20,
			},
		};
	},

	computed: {
		...mapGetters(["isManager", "teacherInfo", "userInfo"]),
		canOperate() {
			return function(creator = {}) {
				if (this.isManager) return true;
				return this.userInfo.id === creator.id;
			};
		},
	},

	created() {
		this.initHandle();
	},

	methods: {
		initHandle() {
			if (!this.teacherInfo || !this.teacherInfo.school_id) {
				setTimeout(() => {
					this.initHandle();
				}, 200);
				return;
			}
			this.params = {
				school_id: this.teacherInfo.school_id,
				after_id: undefined,
				limit: 20,
			};
			this.loading = false;
			this.hasMoreExternal = true;
			this.externalList = [];
			this.getExternalListSource();
		},

		getExternalListSource() {
			if (!this.hasMoreExternal) return;
			if (this.loading) return;
			this.loading = true;
			ExternalService.getExternalListService(this.params)
				.then((res) => {
					this.loading = false;
					this.externalList = [...this.externalList, ...res];
					if (res.length === 20) {
						this.params.after_id = res[res.length - 1].id;
					} else {
						this.hasMoreExternal = false;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},

		createExternalHandle(record) {
			if (record) {
				this.$router.push({
					name: "externalUpdate",
					query: { id: record.id },
				});
				return;
			}
			this.$router.push({ name: "externalCreate" });
		},

		delExternalWordHandle(external) {
			this.$confirm({
				title: "提示信息",
				content: `是否删除当前资料 ${external.title}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						ExternalService.delExternalService({
							id: external.id,
						})
							.then(() => {
								this.$message.success("操作成功");
								const index = this.externalList.findIndex(item => item.id === external.id);
								this.externalList.splice(index, 1);
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		viewExternal(external) {
			window.open(external.url, "_blank");
		},

		scrollChange() {
			const containerH = this.$refs.scrollContainer.offsetHeight;
			const contentH = this.$refs.scrollEle.offsetHeight;
			const scrollTop = this.$refs.scrollContainer.scrollTop;
			if (contentH - containerH - scrollTop < 100) {
				this.getExternalListSource();
			}
		},
	},
};
</script>
  
<style lang="less" scoped>
.external {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;
		padding: 28px 28px 2px 30px;
	}

	&-search {
		margin-bottom: 20px;
	}

	&-content {
		width: calc(100% + 18px);
		height: calc(100vh - 285px);
		overflow-y: auto;
	}
	&-item {
		margin-bottom: 20px;
		padding: 0 20px 0 0;
		list-style: none;
		color: #8590a6;
		font-size: 12px;
		&_title {
			margin-bottom: 5px;
			font-size: 14px;
			font-weight: bold;
			color: #597ab2;
			cursor: pointer;
		}

		&_description {
			margin-top: 4px;
			font-size: 14px;
			color: #333333;
		}
		&_info {
			color: #999;
			margin-top: 8px;
		}

		&_update {
			color: #1890ff;
		}
	}
	&-divider {
		margin: 20px 0 !important;
		font-size: 12px !important;
		color: #cccccc !important;
	}
}
</style>
